const getDownloadFileName = (intro) => {
  const { code } = intro
  return `${code}.png`
}

export default getDownloadFileName
